module.exports = __webpack_public_path__ + "static/media/typ1_icon.4c23ffba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/typ1_icon.svg
// module id = 113
// module chunks = 0